<template>
  <div class="container mx-auto px-4 py-20 max-w-5xl">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "ContainerView",
};
</script>
